import React from "react"

const Avatar = React.forwardRef(({ className = "", children, ...props }, ref) => (
  <div ref={ref} className={`avatar ${className}`} {...props}>
    {children}
  </div>
))
Avatar.displayName = "Avatar"

const AvatarImage = React.forwardRef(({ className = "", src, alt, ...props }, ref) => (
  <img ref={ref} className={`avatar-image ${className}`} src={src || "/placeholder.svg"} alt={alt} {...props} />
))
AvatarImage.displayName = "AvatarImage"

const AvatarFallback = React.forwardRef(({ className = "", children, ...props }, ref) => (
  <div ref={ref} className={`avatar-fallback ${className}`} {...props}>
    {children}
  </div>
))
AvatarFallback.displayName = "AvatarFallback"

export { Avatar, AvatarImage, AvatarFallback }
